import React from 'react';
import { AppsContainer } from './styled';
import { Module } from '../../../../../../../Layout/Header/components/Profile/components/Apps/Module';
export var Modules = function (_a) {
    var apps = _a.apps;
    return (React.createElement(AppsContainer, null, apps.map(function (app) { return (React.createElement(Module, { app: app, key: app.id })); })));
};
//# sourceMappingURL=Modules.js.map